import React, { useState } from 'react';
import CardShimmer from '../../ModelModal/CardShimmer';
import ScrollListener from '../../ModelModal/ScrollListener';
import LoadMore from '../../base/LoadMore';
import { setModelsModalState, useModelsModalState } from '../../../store/state';
import { pageSize, useCateListFetch } from './fetchHander';
import { v4 } from 'uuid';
import { EmptyState } from '../../base/modelLib/EmptyState';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import FlowCard from '../../ModelModal/FlowCard';

const WorkFlowWrapper = (props) => {
  const { cols, modelType, ratio, menus, menuPath, setMenus } = props;
  const { loading, fetchCollect, hasMore, setHasMore } = useCateListFetch(menuPath);
  const workflowData = useModelsModalState('workflowData');
  const [loadmore, setLoadMore] = useState(false);

  const onModelScroll = async () => {
    const target = workflowData[menuPath.menu.code];
    const noMoreData = target?.list.length >= target?.total;
    if (noMoreData) {
      setHasMore(false);
    }
    if (loading || loadmore || noMoreData) return;
    setLoadMore(true);
    const result = await fetchCollect({
      page: target.page + 1,
      pageSize,
      collectionId: menuPath.menu.code,
      requestId: target.requestId ?? v4(),
    });
    setModelsModalState({
      workflowData: {
        ...workflowData,
        [menuPath.menu.code]: {
          ...target,
          page: result.page,
          list: target.list.concat(result.list),
        },
      },
    });
    setLoadMore(false);
  };

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }
  const data = workflowData[menuPath.menu.code]?.list ?? [];
  if (!data.length) return <EmptyState />;
  return (
    <ScrollListener className="flex flex-wrap pl-4 !h-auto" onScroll={() => onModelScroll()}>
      {data.map((item, idx) => (
        <FlowCard data={item} key={idx} ratio={ratio} cols={cols} />
      ))}
      {loadmore && <LoadMore />}
      {!hasMore && (
        <div className="w-full">
          <Divider
            label={translate('history_bottom')}
            color="#EBEBEB"
            className="w-[40%] m-auto"
            styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
          />
        </div>
      )}
    </ScrollListener>
  );
};

export default WorkFlowWrapper;
